import { MagnifyingGlassIcon } from "@phosphor-icons/react";

import FlexWrapper, { AlignItems, JustifyContent } from "@gx/dls/containers/FlexWrapper";
import TextInput from "@gx/dls/inputs/TextInput";
import Text, { TextSize, TextVariant } from "@gx/dls/text/Text";

interface DropzoneWidgetToolbarProps {
  search: string;
  onSearchChange: (search: string) => void;
  numFiles: number;
  isDisabled?: boolean;
}

const DropzoneWidgetToolbar = ({
  search,
  onSearchChange,
  numFiles,
  isDisabled = false,
}: DropzoneWidgetToolbarProps) => {
  return (
    <FlexWrapper
      alignItems={AlignItems.CENTER}
      justifyContent={JustifyContent.SPACE_BETWEEN}
      fillWidth
    >
      <TextInput
        placeholder="Search files"
        leading={{ icon: MagnifyingGlassIcon }}
        value={search}
        onChange={onSearchChange}
        width={240}
        isDisabled={isDisabled}
      />
      <Text size={TextSize.BODY_SM} variant={TextVariant.TERTIARY}>
        {numFiles} {numFiles === 1 ? "file" : "files"}
      </Text>
    </FlexWrapper>
  );
};

export default DropzoneWidgetToolbar;
